import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { lighten, darken } from 'polished';
import GoogleAnalytics from 'react-ga';

import { BLACK, LIGHT_GREY, RED } from '../constants/colors';
import XOSLogo from '../images/logo.png';
import AccountLogin from '../components/AccountLogin';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${LIGHT_GREY};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoginContainer = styled.div`
  height: 295px;
  width: 730px;
  background: white;
  display: flex;
`;

const LoginLogo = styled.div`
  height: 100%;
  width: 305px;
  background: ${BLACK};
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    height: 80px;
    width: 160px;
  }
`;

const ErrorMessage = styled.div`
  width: 730px;
  height: 50px;
  background: ${lighten(0.35, RED)};
  color: ${darken(0.09, RED)};
  border-radius: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
`;

const isProduction = process.env.NODE_ENV === 'production';

function AuthenticationLayout({ error, t }) {
  return (
    <Container>
      {!!error && <ErrorMessage id="Login.FailedText">{t(error)}</ErrorMessage>}
      {isProduction && GoogleAnalytics.pageview('/login')}
      <LoginContainer>
        <LoginLogo>
          <img id="Login.Logo" alt="XOS Digital" src={XOSLogo} />
        </LoginLogo>
        <AccountLogin />
      </LoginContainer>
    </Container>
  );
}

AuthenticationLayout.propTypes = {
  error: PropTypes.string, // comes from
  t: PropTypes.func.isRequired, // comes from withTranslation
};

AuthenticationLayout.defaultProps = {
  error: null,
};

const mapStateToProps = state => ({
  error: state.auth.error,
});

const TranslatedComponent = withTranslation()(AuthenticationLayout);

export default connect(mapStateToProps)(TranslatedComponent);
